/* eslint-disable react-hooks/exhaustive-deps */

import * as Yup from 'yup'
import Select from 'react-select'
import {Col, Row} from 'react-bootstrap'
import {FC, useState, useEffect} from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {useFormik} from 'formik'

import {getUsers} from '../core/_requests'
import {useListView} from '../core/ListViewProvider'
import {useQueryResponse} from '../core/QueryResponseProvider'

type Props = {
  isMessageLoading: boolean
  message: any
}

const PartyLedgerEditModalForm: FC<Props> = ({message, isMessageLoading}) => {
  const dropDownBranchList = useSelector((state: any) => state.commonList.branchList)
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const [loading, setLoading] = useState<any>(false)
  const [senderPartyLedgerList, setSenderPartyLedgerList] = useState<any>([])
  const [receiverPartyLedgerList, setReceiverPartyLedgerList] = useState<any>([])
  const [selectedSenderPartyLedgerId, setSelectedSenderPartyLedgerId] = useState(null)
  const [selectedReceiverPartyLedgerId, setSelectedReceiverPartyLedgerId] = useState(null)
  const [initialPartyLedgerList, setInitialPartyLedgerList] = useState([])
  const [receiverBranchId, setReceiverBranchId] = useState<any>()
  let data = JSON.parse(localStorage.getItem('data') as any)
  const dispatch = useDispatch()
  const intl = useIntl()
  const redirectList = useSelector((state: any) => state.commonList.redirectList)
  const editMessageSchema = Yup.object().shape({
    senderPartyId: Yup.string().required(
      `${intl.formatMessage({id: 'RECEIVER.BRANCH.IS.REQUIRED'})}`
    ),
    receiverPartyId: Yup.string().required(
      `${intl.formatMessage({id: 'RECEIVER.BRANCH.IS.REQUIRED'})}`
    ),
    amount: Yup.number()
      .required(`${intl.formatMessage({id: 'POINT.IS.REQUIRED'})}`)
      .min(1, 'Amount must be at least 1')
      .typeError('Amount must be a number'),

    narration: Yup.string().required('Remarks is required.'),
  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const moduleName = useSelector((state: any) => state.shortCut.module_name)
  useEffect(() => {
    if (moduleName == 'reloadAddMessage') {
      refetch()
    }
  }, [moduleName])
  const MessageData = {
    senderPartyId: '',
    receiverPartyId: '',
    amount: '',
    narration: '',
  }

  useEffect(() => {
    if (itemIdForUpdate) {
      formik.setFieldValue('senderPartyId', message?.responseData?.senderPartyId)
      formik.setFieldValue('receiverPartyId', message?.responseData?.receiverPartyId)
      formik.setFieldValue('amount', message?.responseData?.amount)
      setSelectedSenderPartyLedgerId(message?.responseData?.senderPartyId)
      setSelectedReceiverPartyLedgerId(message?.responseData?.receiverPartyId)
      formik.setFieldValue('narration', message?.responseData?.remarks)
    }
  }, [itemIdForUpdate])

  const formik = useFormik({
    initialValues: MessageData,
    validationSchema: editMessageSchema,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true)
      try {
        setLoading(true)
      } catch (error) {
        setLoading(false)
      } finally {
        setLoading(false)
      }
    },
  })

  const getPartyList = async (search: any) => {
    try {
      let {responseStatus, responseData} = (await getUsers(search)) as any
      if (responseStatus == 200 && responseData && responseData.length) {
        let partyLedger = responseData.map((x: any) => {
          return {
            label: x.party_name,
            value: x.uuid,
            ...x,
          }
        })
        partyLedger = [{value: null, label: 'Select..'}, ...partyLedger]

        setInitialPartyLedgerList(partyLedger)
        setSenderPartyLedgerList(partyLedger)
        setReceiverPartyLedgerList(partyLedger)
      } else {
        setInitialPartyLedgerList([])
        setSenderPartyLedgerList([])
        setReceiverPartyLedgerList([])
      }
    } catch (err: any) {
      let message = err?.message
        ? err.message
        : err?.responseMessage
        ? err.responseMessage
        : ('Something went wrong' as any)
      // dispatch(setMessage('error', message))
    }
  }

  const handleSenderPartyLedgerChange = (selectedOption: any) => {
    setSelectedSenderPartyLedgerId(selectedOption ? selectedOption.value : null)
    formik.setFieldValue('senderPartyId', selectedOption ? selectedOption.value : '')
  }

  const handleReceiverPartyLedgerChange = (selectedOption: any) => {
    setSelectedReceiverPartyLedgerId(selectedOption ? selectedOption.value : null)
    formik.setFieldValue('receiverPartyId', selectedOption ? selectedOption.value : '')
  }

  const filteredSenderPartyLedgerList = senderPartyLedgerList.filter(
    (x: any) => x.value !== selectedReceiverPartyLedgerId
  )
  const filteredReceiverPartyLedgerList = receiverPartyLedgerList.filter(
    (x: any) => x.value !== selectedSenderPartyLedgerId
  )
  useEffect(() => {
    // getPartyList('')
  }, [])

  return (
    <>
      <form
        id='kt_modal_add_message_form'
        className='form'
        noValidate
        onSubmit={formik.handleSubmit}
      >
        <div
          className='d-flex flex-column scroll-y mb-2 me-n7 pe-3 ps-3'
          id='kt_modal_add_Message_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_Message_header'
          data-kt-scroll-wrappers='#kt_modal_add_Message_scroll'
          data-kt-scroll-offset='300px'
        >
          <Row className='mb-8'>
            <Col lg={6}>
              <label className='required fw-bold fs-6 mb-2'>
                <FormattedMessage id='CREDIT.PARTY' />
              </label>
              <Select
                options={filteredSenderPartyLedgerList}
                className='custom_select mb-3'
                placeholder={intl.formatMessage({id: 'SELECT'})}
                onChange={handleSenderPartyLedgerChange}
                value={filteredSenderPartyLedgerList.find(
                  (option: any) => option.value === selectedSenderPartyLedgerId
                )}
              />
              {formik.touched.senderPartyId && formik.errors.senderPartyId && (
                <div className='fv-plugins-message-container text-danger'>
                  <span role='alert'>{formik.errors.senderPartyId as any}</span>
                </div>
              )}
            </Col>
            <Col lg={6}>
              <label className='required fw-bold fs-6 mb-2'>
                <FormattedMessage id='DEBIT.PARTY' />
              </label>
              <Select
                options={filteredReceiverPartyLedgerList}
                className='custom_select mb-3'
                placeholder={intl.formatMessage({id: 'SELECT'})}
                onChange={handleReceiverPartyLedgerChange}
                value={filteredReceiverPartyLedgerList.find(
                  (option: any) => option.value === selectedReceiverPartyLedgerId
                )}
              />
              {formik.touched.receiverPartyId && formik.errors.receiverPartyId && (
                <div className='fv-plugins-message-container text-danger'>
                  <span role='alert'>{formik.errors.receiverPartyId as any}</span>
                </div>
              )}
            </Col>
          </Row>

          <Row className='mb-8'>
            <Col lg={6}>
              <label className='required fw-bold fs-6 mb-2'>
                {/* <FormattedMessage id='POINT' /> */} Amount
              </label>
              <input
                placeholder={intl.formatMessage({id: 'POINT'})}
                type='text'
                name='receiver_name'
                className='form-control form-control-solid mb-2 mb-lg-0'
                onChange={(e: any) => {
                  formik.setFieldValue('amount', e.target.value)
                  // !formik?.values?.is_journal && onPointAdded(e.target.value)
                }}
                value={formik?.values?.amount}
              />
              {formik.touched.amount && formik.errors.amount && (
                <div className='fv-plugins-message-container text-danger'>
                  <span role='alert'>{formik.errors.amount as any}</span>
                </div>
              )}
            </Col>
            <Col lg={6}>
              <label className='required fw-bold fs-6 mb-2'>
                {/* <FormattedMessage id='NARRATION' /> */}
                Remarks
              </label>
              <textarea
                placeholder={intl.formatMessage({id: 'NARRATION'})}
                name='Narration'
                maxLength={200}
                rows={3}
                className='form-control form-control-solid mb-3'
                required
                onChange={(e: any) => {
                  formik.setFieldValue('narration', e.target.value.trimStart())
                }}
                value={formik?.values?.narration}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault() // Prevent default newline behavior
                    formik.handleSubmit() // Submit the form
                  }
                }}
              />
              {formik.touched.narration && formik.errors.narration && (
                <div className='fv-plugins-message-container text-danger'>
                  <span role='alert'>{formik.errors.narration as any}</span>
                </div>
              )}
            </Col>
          </Row>
          <Row className='mb-5'></Row>
        </div>
        <div className='text-end pe-4 mb-6 pt-5 '>
          <button type='submit' className=' btn me-3 text-white mb-3 mb-md-0'>
            <span className='indicator-label'>
              {loading ? 'Please Wait...' : intl.formatMessage({id: 'SUBMIT'})}
            </span>
          </button>

          <button
            type='reset'
            onClick={() => {
              cancel()
            }}
            className='btn btn-light me-3 mb-3 mb-md-0'
          >
            Cancel
            {/* <FormattedMessage id='CANCEL' /> */}
          </button>
        </div>
      </form>
      {/* {(formik.isSubmitting || isMessageLoading) && <MessageListLoading />} */}
    </>
  )
}

export {PartyLedgerEditModalForm}
